module.exports = __webpack_public_path__ + "video/1100_2_HC_2023_Permissions.0a23ae62.vtt";